/* IMPORTANT: "campaign" and "phase" have the same meaning. */
import idKeyFactory from "helpers/idKeyFactory";

/**
 * @returns ['phase']
 * */
export const phaseKey = () => ["phase"];

/**
 * @param {string | number} ID
 *
 * @returns {['phase', { id: string }] | ['phase']}
 * */
export const phaseIdKey = idKeyFactory(phaseKey);

/**
 * @param {string | number} id
 * @param {Object} queryParams
 *
 * @return {['phase', { id: string }, Object] | ['phase', Object]}
 * */
export const phaseIdWithQueryParams = ({ id, queryParams }) => [...phaseIdKey(id), queryParams];
